import * as React from 'react';
// import LazyLoad from 'react-lazyload';
import PropTypes from 'prop-types';
import Link from 'next/link';

import { StyledImage, StyledSVG, StyledNonSVG } from './style';
// import PlaceholderImage from '../../../static/images/placeholder.svg';

const CustomImage = React.forwardRef((props, ref) => {
  const {
    src,
    alt,
    width,
    height,
    href,
    responsive,
    rounded,
    opacity,
    filter,
    onClick,
    svg,
    className,
    color,
    fitCover,
    draggable,
  } = props;

  let Cmp = React.createElement(StyledImage, {
    ref,
    className,
    src,
    alt: alt || src,
    imageWidth: width,
    imageHeight: height,
    responsive,
    rounded,
    opacity,
    filter,
    onClick,
    fitCover,
    draggable,
    onError: e => {
      e.target.onerror = null;
      e.target.src = '/images/placeholder.svg';
      e.target.style.objectFit = 'cover';
    }
  });

  if (svg && typeof window !== 'undefined') {
    Cmp = React.createElement(StyledSVG, {
      ref,
      className,
      src,
      alt: alt || src,
      width,
      height,
      responsive,
      rounded,
      opacity,
      filter,
      onClick
    }, "Your browser doesn't support XHR or inline SVGs.");
  }

  if (color && svg && typeof window === 'undefined') {
    Cmp = React.createElement(StyledNonSVG, {
      ref,
      src,
      alt: alt || src,
      width,
      height,
      responsive,
      rounded,
      opacity,
      filter,
      onClick,
      color,
      fitCover,
      draggable
    });
  }

  const Clicable = React.createElement(Link, {
    href: href || '#0',
    passHref: true
  }, React.createElement('a', {
    href: '#0'
  }, Cmp));

  // if (typeof window !== 'undefined') {
  //   if (svg) {
  //     return <React.Fragment>{href ? Clicable : Cmp}</React.Fragment>;
  //   }
  //   return <LazyLoad>{href ? Clicable : Cmp}</LazyLoad>;
  // }

  return React.createElement(React.Fragment, null, href ? Clicable : Cmp);
});

CustomImage.displayName = 'CustomImage';

CustomImage.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  href: PropTypes.string,
  responsive: PropTypes.bool,
  rounded: PropTypes.number,
  opacity: PropTypes.number,
  filter: PropTypes.string,
  onClick: PropTypes.func,
  svg: PropTypes.bool,
  color: PropTypes.string,
  fitCover: PropTypes.bool,
  draggable: PropTypes.bool,
};

CustomImage.defaultProps = {
  className: null,
  alt: '',
  href: null,
  responsive: false,
  rounded: null,
  opacity: null,
  filter: null,
  width: '100%',
  height: null,
  onClick: null,
  svg: null,
  color: null,
  fitCover: false,
  draggable: true,
};

export default CustomImage;
